/** Skeleton: surface-coloured placeholders; appears after 300 ms via the Loading helper (never earlier). */
import { useEffect, useState, type CSSProperties, type ReactElement, type ReactNode } from "react";
export function Skeleton({ width = "100%", height = 24, circle = false, className = "", style }: { width?: number | string; height?: number | string; circle?: boolean; className?: string; style?: CSSProperties }): ReactElement {
  return <div className={`skeleton ${circle ? "skeleton--circle" : ""} ${className}`} style={{ width, height, ...style }} aria-hidden="true" />;
}
/** Shows children only after `delay` ms (default 300) so quick loads never flash a placeholder. */
export function Loading({ children, delay = 300, label = "Loading…" }: { children: ReactNode; delay?: number; label?: string }): ReactElement | null {
  const [show, setShow] = useState(delay === 0);
  useEffect(() => { if (delay === 0) return; const t = setTimeout(() => setShow(true), delay); return () => clearTimeout(t); }, [delay]);
  if (!show) return null;
  return <div role="status" aria-label={label}>{children}</div>;
}
